/**
 * 레슨 상세 조회 커스텀 훅
 *
 * react-query를 사용하여 레슨 상세 데이터를 fetch하고 캐싱
 * - 자동 리페칭 및 캐시 관리
 * - 로딩/에러 상태 관리
 * - 챕터 및 강의 정보 포함
 */

import { useQuery } from "@tanstack/react-query";
import { getLessonDetail } from "../api/lessonApi";

/**
 * 레슨 상세 조회 훅
 *
 * @param lessonId - 레슨 ID
 * @param options - 추가 옵션 (enabled 등)
 * @returns react-query의 useQuery 결과 (data, isLoading, isError 등)
 */
export const useLessonDetail = (
  lessonId: number,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["lesson", lessonId],
    queryFn: () => getLessonDetail(lessonId),
    staleTime: 1000 * 60 * 5, // 5분간 캐시 유지
    gcTime: 1000 * 60 * 10, // 10분간 가비지 컬렉션 유예
    enabled: options?.enabled !== undefined ? options.enabled : !!lessonId, // lessonId가 있을 때만 쿼리 실행
  });
};

